import { isEqual } from "lodash";

import { useAppSelector } from "./redux_hooks";

import { RootState } from "shared/types";
import { UserType } from "shared/types/user";

export const PROFILE_PROPERTIES: (keyof UserType)[] = [
  "aws_avatar_key",
  "email",
  "first_name",
  "last_name",
  "role",
  "title",
];

export const USER_PICKER_PROPERTIES: (keyof UserType)[] = [
  "av",
  "classroom_talk_time",
  "filter_count",
  "is_performing_av_check",
  "is_present",
  "is_speaking",
  "role",
];

const _selectUserById = (id: string) => (state: RootState) =>
  id in state.classroom.client.users ? state.classroom.client.users[id] : null;

const _selectUsers = () => (state: RootState) => state.classroom.client.users;

export const useUserProperties = (id: string, properties: (keyof UserType)[]) =>
  useAppSelector(_selectUserById(id), (a, b) => {
    if (a && b && properties.length > 0) {
      return properties.every((property) => isEqual(a[property], b[property]));
    }
    return a === b;
  });

export const useUsersProperties = (properties: (keyof UserType)[]) =>
  useAppSelector(_selectUsers(), (a, b) => {
    if (properties.length > 0) {
      return (
        Object.keys(a).join(",") === Object.keys(b).join(",") &&
        Object.keys(a).every((userId) => {
          return properties.every((property) => isEqual(a[userId][property], b[userId][property]));
        })
      );
    }
    return a === b;
  });

export const useUserProfileProperties = (id: string) => useUserProperties(id, PROFILE_PROPERTIES);

export const useUsersProfileProperties = () => useUsersProperties(PROFILE_PROPERTIES);
